var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({ref:"input",class:{['mb-5']: true, ['upper-text']: true},attrs:{"outlined":_vm.outlined,"append-icon":_vm.icone,"background-color":"white"},on:{"click:append":_vm.action},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }